import { ActionMap } from "@context/types/index";

export enum TypesPersonality {
  Natural = "NATURAL",
  Legal = "LEGAL",
}

export type legalPersonalityPayload = {
  [TypesPersonality.Natural]: undefined;
  [TypesPersonality.Legal]: undefined;
};

export type legalPersonalityActions = ActionMap<
  legalPersonalityPayload
>[keyof ActionMap<legalPersonalityPayload>];
